export default __webpack_public_path__ + "static/media/warning--ramp-closed--g1.b7091862.png";